import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '@dabnet-kamu/libs/ui';
import { DONUS_URL_ANAHTARI } from '../../auth.guard';

@Component({
  selector: 'dk-auth-login-callback',
  standalone: true,
  imports: [CommonModule],
  template: ``,
  styles: [``],
})
export class LoginCallbackComponent {


  constructor(private authService: AuthService, private readonly router: Router,
    private _activatedRoute: ActivatedRoute, private utilsService: UtilsService) {


    // Girişe gönderilmeden önce AuthGuard'ın sakladığı adres (adres çubuğundan açılan sayfa, yenileme, yeni sekme)
    const donusUrl = this.donusUrlAl();

    this.authService.completeAuthentication().subscribe({
      next: () => {

        // eski hâli (13.10.2026): yalnız redirectURL sorgu parametresine bakılıyordu; guard onu vermediği için
        // her giriş /signed-in-redirect → main/dabnet'e düşüyordu.
        // const redirectURL = this._activatedRoute.snapshot.queryParamMap.get('redirectURL') || '/signed-in-redirect';
        const redirectURL = donusUrl || this._activatedRoute.snapshot.queryParamMap.get('redirectURL') || '/signed-in-redirect';
        this.router.navigateByUrl(redirectURL);
      },
      error: (err) => {
        this.router.navigateByUrl('/');

      }
    });

  }

  /**
   * Saklanan dönüş adresini okur ve siler (tek kullanımlık). Açık yönlendirmeye karşı yalnız uygulama içi yol kabul edilir:
   * "/" ile başlamalı; "//" ya da "/\" ile başlamamalı (tarayıcı bunları başka siteye gider sayar).
   */
  private donusUrlAl(): string | null {
    let url: string | null = null;
    try {
      url = sessionStorage.getItem(DONUS_URL_ANAHTARI);
      sessionStorage.removeItem(DONUS_URL_ANAHTARI);
    } catch { /* gizli pencere vb. */ }
    if (!url || !url.startsWith('/') || url.startsWith('//') || url.startsWith('/\\')) return null;
    return url;
  }

}
